import Operator from "./Operator";


let Contain = Operator.extend("Contain", {
    literal: ["contain"],

    validateValue(value) {
        return this.validateLiteral(value);
    },

    // TODO: right lowercase cache
    //
    // left is variable,
    // right is string literal
    compile2js(left, right) {
        if ( right == null ) {
            right = "";
        }
        right = right + "";
        right = right.toLowerCase();
        right = JSON.stringify(right);

        // _lowercase @see RowModel.parse2filter
        return "( " + left + " && " + left + "._lowerCase || (" + left + " + '').toLowerCase() ).indexOf( " + right + " ) !== -1";
    }
});

export default Contain;
